// extracted by mini-css-extract-plugin
export var fadeInOut = "_4i-3";
export var icon = "_4i-4";
export var savedIndicator = "_4i-2";
export var savingIndicator = "_4i-0";
export var spin = "_4i-1";